import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const checkWrapper = css`
  position: relative;
  align-self: center;
`;

const CHECK_MARK_TRANSITION_TIME = '0.25s';

// Note: color property has been added to button for iOS safari, as by default the text colour is blue instead of brand black
export const button = css`
  color: var(--neutral-black-base);
  display: flex;
  position: relative;
  padding: ${pxToRem(14)} ${spacing.sm}px;
  width: 100%;
  border-radius: 10px;
  border: solid 1px var(--neutral-black-70);
  background: var(--neutral-white-base);
  font: inherit;
  cursor: pointer;

  &[aria-pressed='true'] {
    border-color: var(--brand-purple-base);
    &:not(.focus-visible) {
      box-shadow: 0 0 ${pxToRem(8)} 0 rgba(0, 0, 0, 0.2);
    }
  }
`;

export const checkmark = css`
  opacity: 0;
  position: absolute;
  left: 0;
  top: ${pxToRem(2)};
  height: ${pxToRem(16)};
  width: ${pxToRem(16)};
  transition: opacity ${CHECK_MARK_TRANSITION_TIME};

  &[data-is-selected='true'] {
    transition: opacity ${CHECK_MARK_TRANSITION_TIME} 0.1s;
    opacity: 1;
  }
`;

export const label = css`
  display: block;
  padding-right: ${pxToRem(28)};
  position: relative;
  transition: padding-left ${CHECK_MARK_TRANSITION_TIME},
    padding-right ${CHECK_MARK_TRANSITION_TIME};

  &[data-is-selected='true'] {
    padding-left: ${pxToRem(28)};
    padding-right: 0;
  }
`;
